import { Box, Grid, styled } from "@mui/material";
import * as React from "react";
import { Link, useLocation } from "react-router-dom";

const ClearLink = styled(Link)({
  color: "black",
  textDecoration: "none",
  textTransform: "none",
});

const BaseGrid = styled(Grid)({
  padding: "5%",
  paddingTop: "10%",
  paddingBottom: "10%",
  margin: "5%",
  marginTop: "15%",
  width: "100%",
  height: "auto",
  border: "2px solid #00ACED",
  borderRadius: "5px",
});

const ItemGrid = styled(Grid)({
  padding: "2%",
  textAlign: "left",
});

export interface IPolicyNavGridProps {}

export function PolicyNavGrid(props: IPolicyNavGridProps) {
  const location = useLocation();
  const [currentPath, setCurrentPath] = React.useState(location.pathname);

  React.useEffect(() => {
    if (location.pathname) {
      setCurrentPath(location.pathname);
    }
  }, [location.pathname]);

  return (
    <BaseGrid container direction="column" justifyContent="flex-start" item>
      {[
        { url: "/Legal/TermsAndCondition", text: "Terms And Conditions" },
        { url: "/Legal/PrivacyPolicy", text: "Privacy Policy" },
      ].map((item, key) => (
        <ItemGrid item key={key}>
          <ClearLink
            to={item.url}
            style={{
              fontWeight: currentPath === item.url ? "bold" : "normal",
            }}
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          >
            {item.text}
          </ClearLink>
        </ItemGrid>
      ))}
    </BaseGrid>
  );
}
